import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavParams } from 'ionic-angular';
import { DailyLogComponent } from '../daily-log-component/daily-log-component.component';
import { AppConfig } from '../../../app/app.config';
import { DateTime } from 'luxon';

@IonicPage()
@Component({
  selector: 'page-daily-log',
  templateUrl: 'daily-log.html',
})
export class DailyLogPage {
  @ViewChild('dailyLog') dailyLog: DailyLogComponent;

  config = AppConfig.settings;
  inputDate: DateTime;

  constructor(
    public navParams: NavParams,
  ) {
    this.inputDate = this.navParams.get('inputDate');
  }

  ionViewWillEnter() {
    this.dailyLog.ionViewEnter();
  }

  ionViewWillLeave() {
    this.dailyLog.ionViewLeave();
  }

  ionViewDidEnter() {
  }
}



// WEBPACK FOOTER //
// ./src/pages/daily-log/daily-log/daily-log.ts